export const LAYOUT_FINANCE_HOME = '/app/home'

export const LAYOUT_FINANCE_PANEL = '/app/finance/panel'

export const LAYOUT_FINANCE_INVOICE_ROOT = '/app/finance/invoice'
export const LAYOUT_FINANCE_INVOICE_VENDOR_LIST = '/app/finance/invoice/vendor/list'
export const LAYOUT_FINANCE_INVOICE_VENDOR_SHOW = (id) => `/app/finance/invoice/vendor/show/${id}`

export const LAYOUT_FINANCE_INVOICE_CLIENT_LIST = '/app/finance/invoice/client/list'
export const LAYOUT_FINANCE_INVOICE_CLIENT_FROM_UNCOMPENSATED_JOBS = '/app/finance/invoice/client/uncompensated'
export const LAYOUT_FINANCE_INVOICE_CLIENT_FROM_PURCHASE_ORDER = '/app/finance/invoice/client/purchase-order'
export const LAYOUT_FINANCE_INVOICE_CLIENT_SHOW = (id) => `/app/finance/invoice/client/show/${id}`
export const LAYOUT_FINANCE_INVOICE_CLIENT_SHOW_PURCHASE_ORDER = (id) =>
    `/app/finance/invoice/client/show-purchase-order/${id}`
export const LAYOUT_FINANCE_INVOICE_CLIENT_ASSIGN_JOB = (invoiceId, invoiceDetailPurchaseOrderId, name, clientId) =>
    `/app/finance/invoice/client/assignJob/${invoiceId}/${invoiceDetailPurchaseOrderId}/${name}/${clientId}`
export const LAYOUT_FINANCE_INVOICE_CLIENT_ADD_JOB = (invoiceId, clientId) =>
    `/app/finance/invoice/client/add-job/${invoiceId}/${clientId}`

export const LAYOUT_FINANCE_PAYMENT_ROOT = '/app/finance/payment'
export const LAYOUT_FINANCE_PAYMENT_VENDOR_LIST = '/app/finance/payment/vendor/list'
export const LAYOUT_FINANCE_PAYMENT_VENDOR_SHOW = (id) => `/app/finance/payment/vendor/show/${id}`
export const LAYOUT_FINANCE_PAYMENT_VENDOR_NEW = (id) => `/app/finance/payment/vendor/new/${id}`
export const LAYOUT_FINANCE_PAYMENT_CLIENT_LIST = '/app/finance/payment/client/list'
export const LAYOUT_FINANCE_PAYMENT_CLIENT_SHOW = (id) => `/app/finance/payment/client/show/${id}`
export const LAYOUT_FINANCE_PAYMENT_CLIENT_NEW = (id) => `/app/finance/payment/client/new/${id}`

export const LAYOUT_FINANCE_PURCHASE_ORDER_ROOT = '/app/finance/purchase-order'
export const LAYOUT_FINANCE_PURCHASE_ORDER_LIST = '/app/finance/purchase-order/list'
export const LAYOUT_FINANCE_PURCHASE_ORDER_TASK = '/app/finance/purchase-order/task'
export const LAYOUT_FINANCE_PURCHASE_ORDER_FORM = '/app/finance/purchase-order/form'
export const LAYOUT_FINANCE_PURCHASE_ORDER_SHOW = (id) => `/app/finance/purchase-order/show/${id}`
export const LAYOUT_FINANCE_PURCHASE_ORDER_ASSIGN_TASK = (id, code, vendorId) =>
    `/app/finance/purchase-order/assign/${id}/${code}/${vendorId}`
